module.exports = __webpack_public_path__ + "images/team/anton-sizikov@2x.png";